"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.put = exports.post = exports.get = exports.del = void 0;
var _lcHttp = _interopRequireDefault(require("lc-http"));
// We can place this in the pf-component-library as a util function.

var get = exports.get = function get(url) {
  return _lcHttp.default.get(url);
};
var post = exports.post = function post(url, payload) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _lcHttp.default.post(url, payload, options);
};
var put = exports.put = function put(url) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _lcHttp.default.put(url, payload, options);
};
var del = exports.del = function del(url) {
  return _lcHttp.default.delete(url);
};
